<div class="wrapper">
  <div class="d-flex flex-column">
    <ng-container *ngTemplateOutlet="!show ? list : ''"></ng-container>
    <div *qmAuth="'objectdescription-actions'">
      <ng-container *ngTemplateOutlet="show ? form : add"></ng-container>
    </div>
  </div>
</div>

<ng-template #add>
  <div class="add">
    <button type="button" class="btn btn-outline-success" (click)="addText($event)"
      ngbTooltip="{{ 'Add a custom note for the element' | translate }}">
      {{'Add text' | translate}}
    </button>
  </div>
</ng-template>

<ng-template #list>
  <div class="d-flex flex-column object-descriptions" *ngFor="let s of objectDescriptions; let i = index">
    <div id="link-{{i}}">
      {{getText(s.description, i)}}
    </div>
    <div class="d-flex flex-row small-text" *qmAuth="'objectdescription-actions'">
      <a (click)="removeLink(s, $event)">
        <svg class="svg-inline--fa fa-w-20">
          <use xlink:href="#trash"></use>
        </svg>
      </a>
      <a (click)="edit(s, $event)">
        <svg class="svg-inline--fa fa-w-20">
          <use xlink:href="#edit"></use>
        </svg>
      </a>
    </div>
  </div>
</ng-template>

<ng-template #form>
  <div class="form-body">
    <div style="width: 100%;">
      <textarea qmAutosize class="form-control" id="defTextarea"
                [(ngModel)]="text"
                placeholder="{{'Description' | translate}}"
                rows="1" cols="50"></textarea>
    </div>
    <div class="d-flex flex-row actions" style="width: 100%;">
      <div class="buttons">
        <button type="button" class="btn btn-outline-success" (click)="saveDescription(newDescription, $event)">
          {{'Save' | translate}}
        </button>
      </div>
      <div class="buttons" style="margin-left: 0.5em;">
        <button type="button" class="btn btn-outline-warning" (click)="cancel($event)">
          {{'Cancel' | translate}}
        </button>
      </div>
    </div>
  </div>
</ng-template>

<i class="far fa-trash-alt" data-fa-symbol="trash"></i>
<i class="far fa-edit" data-fa-symbol="edit"></i>
